"use strict";
var asap = require("asap");
var window = require("global");

var soundPreloadMap = {};

function Sound(fileName, basePath, onError) {
	if (fileName)
		fileName = fileName[0].slice(1);
	this._sound = fileName;

	if (!soundPreloadMap[fileName]) {
		window.plugins.NativeAudio.preloadComplex(fileName, fileName, 1, 1, 0, function () {
			if (onError) asap(onError);
			soundPreloadMap[fileName] = true;
		}, function (msg) {
			console.log("error: " + msg);
			onError(msg);
		});
	}
}

Sound.prototype = {
	_sound: null,
	play: play,
	pause: pause,
	stop: pause,
	setVolume: setVolume,
	setCurrentTime: setCurrentTime,
	isLoaded: isLoaded,
};

// TODO: Put URL that makes sense here
Sound.MAIN_BUNDLE = process.env.PUBLIC_URL;

module.exports = Sound;

function play(cb) {
	var sound = this._sound;

	if (cb) {
		window.plugins.NativeAudio.play(sound, function () { }, cb, cb);
	}

	return this;
}

function pause() {
	var sound = this._sound;
	try {
		window.plugins.NativeAudio.stop(sound);
	} catch (e) {
		console.error("Sound Error", e);
	}

	return this;
}

function setVolume() {
	return this;
}


function setCurrentTime() {
	return this;
}

function isLoaded() {
	return true;
}